import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { deleteBudgetRecord } from "../../../store/spendCategorization/budgetSlice";

const DeleteConfirmationDialog = ({ open, onClose, record }) => {
  const dispatch = useDispatch();
  const { isDeletingBudgetRecord } = useSelector((state) => state.budget);

  const handleDelete = () => {
    if (record && record.budget_id) {
      dispatch(deleteBudgetRecord(record.budget_id));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="delete-dialog-title"
        sx={{
          fontWeight: 600,
          color: '#1e293b',
          fontSize: '1.125rem',
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: '#f8fafc',
        }}
      >
        Confirm Deletion
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Typography variant="body1" sx={{ color: '#374151', mb: 2 }}>
          Are you sure you want to delete the budget record for{" "}
          <strong>{record?.resource_group_name}</strong>?
        </Typography>
        <Box sx={{ 
          backgroundColor: '#fef2f2', 
          p: 2, 
          borderRadius: '8px',
          border: '1px solid #fecaca'
        }}>
          <Typography variant="body2" sx={{ color: '#991b1b', fontWeight: 500 }}>
            This action cannot be undone. The budget record and all associated data will be permanently deleted.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, borderTop: '1px solid #e2e8f0', backgroundColor: '#f8fafc' }}>
        <Button
          onClick={onClose}
          disabled={isDeletingBudgetRecord}
          sx={{
            borderColor: '#d1d5db',
            color: '#374151',
            '&:hover': {
              borderColor: '#9ca3af',
              backgroundColor: '#f9fafb',
            },
          }}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          disabled={isDeletingBudgetRecord}
          sx={{
            backgroundColor: '#ef4444',
            color: 'white',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#dc2626',
            },
            '&:disabled': {
              backgroundColor: '#9ca3af',
            },
          }}
          variant="contained"
        >
          {isDeletingBudgetRecord ? (
            <>
              <CircularProgress size={16} sx={{ color: 'white', mr: 1 }} />
              Deleting...
            </>
          ) : (
            "Delete"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
